module.exports = __webpack_public_path__ + "img/hero-bio.d58bd2e4.webp";